/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

( function() {
    
    if($('.clients--wrap').length){
        var $grid = $('.clients--wrap').isotope({
            itemSelector: '.clients--item',
            filter: "*",
            getSortData:{
                order: '[data-order] parseInt'
            },
            sortBy : 'order'
        });

        $grid.imagesLoaded().progress( function() {
            $grid.isotope('layout');
        }); 
        $('.filter--box li a').on('click', function(e){
            e.preventDefault();
            var selector = $(this).attr('data-filter');

            $('.clients--wrap').isotope({
                filter: selector
            });

            $('.filter--box li a').removeClass('active');
            $(this).addClass('active');
        });

        $('#sorting').on('change', function (){
            var sorting = $(this).val();
            $('.clients--wrap').isotope({
                filter: sorting
            });

        });
        $('.js-sort-radio').on('change', function (){
            var sorting = $(this).val();
            var title = $(this).data('title');
            $('.js-sort-title').html(title);
            $('.clients--wrap').isotope({
                filter: sorting
            });

        });

    }
    
    if($('.blog--wrap').length){
        var $grid = $('.blog--wrap').isotope({
            itemSelector: '.blog--item',
            filter: "*",
            getSortData:{
                order: '[data-order] parseInt'
            },
            sortBy : 'order'
        });

        $grid.imagesLoaded().progress( function() {
            $grid.isotope('layout');
        }); 
        $('.filter--box li a').on('click', function(e){
            e.preventDefault();
            var selector = $(this).attr('data-filter');

            $('.blog--wrap').isotope({
                filter: selector
            });

            $('.filter--box li a').removeClass('active');
            $(this).addClass('active');
        });

        $('#sorting').on('change', function (){
            var sorting = $(this).val();

            $('.blog--wrap').isotope({
                filter: sorting
            });

        });
        $('.js-sort-radio').on('change', function (){
            var sorting = $(this).val();
            var title = $(this).data('title');
            $('.js-sort-title').html(title);
            $('.blog--wrap').isotope({
                filter: sorting
            });

        });

    }
    
} )();